import React, { useId } from 'react';
import TicketSelectOption from './TicketSelectOption';

const TicketAssigneeSelect = ({ search, onSearch, matchesSelection, options, onSelect, disabled, required }) => {
  const id = useId();
  return <div>
    <label className="ticket-create-label" htmlFor={id}>Owner{required ? ' *' : ' (optional)'}</label>
    <div className="ticket-create-select">
      <input id={id} className="input" value={search} onChange={event => onSearch(event.target.value)} placeholder="Search people" disabled={disabled} />
      {search.trim() && !matchesSelection && <div className="ticket-create-options">
        {options.length ? options.slice(0, 10).map(user => <TicketSelectOption key={user._id}
          disabled={disabled} onClick={() => onSelect(user)} label={user.username || user.email}
          description={[user.role?.replace(/_/g, ' '), user.email].filter(Boolean).join(' · ')} />)
          : <span className="ticket-create-no-results">No person found.</span>}
      </div>}
    </div>
  </div>;
};

export default TicketAssigneeSelect;
